import { ExLink, LinkSize } from '@boomi/exosphere';
import type { Connector } from '../connectors/connectors';
import styles from './Connection.module.css';

interface ConnectorSidebarProps {
    connector: Connector;
    onBack?: (() => void) | undefined;
}

const ConnectorSidebar = ({ connector, onBack }: ConnectorSidebarProps) => (
    <div className={`${styles.connectorSidebar} ${onBack ? styles.connectorSidebarWithBack : ''}`}>
        {onBack && (
            <ExLink
                data-pendo-link="config-sidebar-allconnectors"
                leadingIcon="Left arrow"
                size={LinkSize.SMALL}
                onClick={onBack}
            >
                All Connectors
            </ExLink>
        )}
        {connector.icon && (
            <img
                src={connector.icon}
                alt={connector.name}
                width={56}
                height={56}
                className={styles.connectorIcon}
            />
        )}
        <div className={styles.connectorSidebarName}>{connector.name}</div>
        {connector.description && (
            <div className={styles.connectorSidebarDescription}>{connector.description}</div>
        )}
    </div>
);

export default ConnectorSidebar;
